// content items
export const ADD_PARTS = 'ADD_PARTS';
export const REMOVE_PART = 'REMOVE_PART';
export const CHANGE_PART_QUANTITY = 'CHANGE_PART_QUANTITY';
export const RESET_ORDER = 'CLEAR_ORDER';

export const CHANGE_ACCESSORY_CHOICES = 'CHANGE_ACCESSORY_CHOICES';
export const CHANGE_FILTER_CHOICES = 'CHANGE_FILTER_CHOICES';

export const LOAD_PARTS_REQUEST = 'LOAD_PARTS_REQUEST';
export const LOAD_PARTS_SUCCESS = 'LOAD_PARTS_SUCCESS';
export const LOAD_PARTS_ERROR = 'LOAD_PARTS_ERROR';

export const LOAD_MONITORS_REQUEST = 'LOAD_MONITORS_REQUEST';
export const LOAD_MONITORS_SUCCESS = 'LOAD_MONITORS_SUCCESS';
export const LOAD_MONITORS_ERROR = 'LOAD_MONITORS_ERROR';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const LOAD_LANGUAGE_STRINGS_REQUEST = 'LOAD_LANGUAGE_STRINGS_REQUEST';
export const LOAD_LANGUAGE_STRINGS_SUCCESS = 'LOAD_LANGUAGE_STRINGS_SUCCESS';
export const LOAD_LANGUAGE_STRINGS_ERROR = 'LOAD_LANGUAGE_STRINGS_ERROR';

export const ACCEPTED_LICENSE = 'ACCEPTED_LICENSE';
export const VIEW_ORDER_IMAGES = 'VIEW_ORDER_IMAGES';
